import WiglyArrowUpIcon from '@/assets/icons/wiggly-arrow-up.svg?react';
import doctorsBubblesImg from '@/assets/images/home/doctors-bubbles.png';
import heroWomanRoofImg from '@/assets/images/home/hero-woman-roof.png';
import morningAndEveningPacksImg from '@/assets/images/home/morning-and-evening-packs.png';
import pillImg from '@/assets/images/home/pill.png';
import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { StarFilled as StarFilledIcon } from '@carbon/icons-react';
import { Link } from '@tanstack/react-router';

export function HeroSection() {
  const { isDesktop, isBigDesktop } = useBreakpoint();

  return (
    <Section className="flex flex-col items-center lg:relative lg:flex-row lg:items-start lg:justify-between lg:pt-25">
      <div className="flex flex-col items-center lg:items-start">
        <Heading as="h1" className="mb-5 lg:mb-6 lg:max-w-89 lg:text-left">
          Personalised supplements,{' '}
          <span className="text-primary">just for you</span>
        </Heading>

        <p className="text-muted-foreground text-center text-base leading-5.5 lg:mb-11 lg:max-w-99 lg:text-left">
          Your health data. Our doctors. Supplements that actually fit you.
        </p>

        {!isDesktop && (
          <img
            className="mb-2 w-full max-w-120 min-w-0"
            src={morningAndEveningPacksImg}
            alt="Morning and Evening Packs"
          />
        )}

        <Button className="mb-10 w-fit lg:mb-13.25 lg:min-w-51.5">
          <Link to={routes.auth.login}>Start today</Link>
        </Button>

        <div className="mb-8 flex items-center gap-4.25 text-sm leading-7.5">
          <img
            className="h-9.75 w-21.5 object-contain"
            src={doctorsBubblesImg}
            alt="Doctors Bubbles"
          />

          <div>
            <div className="flex gap-[0.09375rem]">
              {Array.from({ length: 5 }).map((_, i) => (
                <StarFilledIcon key={i} className="size-4.5 text-[#FCCA60]" />
              ))}
            </div>

            <p className="text-sm">Preferred by 100+ doctors</p>
          </div>
        </div>
      </div>

      {isBigDesktop && (
        <img
          className="-mt-19 max-w-136"
          src={morningAndEveningPacksImg}
          alt="Morning and Evening Packs"
        />
      )}

      <div className="flex flex-col items-center lg:-mt-11.75">
        <img
          className="mb-5.5 h-73.5 w-72.5"
          src={heroWomanRoofImg}
          alt="Hero Woman Roof"
        />

        <p className="mb-5.5 flex items-center gap-0.75 text-xl leading-7.5 lg:justify-center">
          Improved focus <WiglyArrowUpIcon />
        </p>

        <div className="flex items-center gap-7 lg:justify-center">
          <img
            className="h-16.75 w-8.5 shrink-0 scale-135 object-cover filter-[drop-shadow(-0.125rem_0.125rem_0.25rem_#FE972180)_drop-shadow(-0.3125rem_0.375rem_0.625rem_#FE97214D)_drop-shadow(-0.4375rem_0.5rem_1.125rem_#FE972133)]"
            src={pillImg}
            alt="Pill"
          />

          <p className="max-w-41 leading-6.5">
            Feel better without the guesswork.
          </p>
        </div>
      </div>
    </Section>
  );
}
